import { Document, Page, Text, View, StyleSheet} from '@react-pdf/renderer';

import {style} from '../../../components/pdf/fontstyles';
import {AutoText} from '../../../components/pdf/autoText'; 




const styles = StyleSheet.create({
   
          solidLine: {
           
            borderBottomWidth: 1,   // thickness of the line
            borderBottomColor: '#000', // color (black here)
            width: '100%',         // full width of page or container
          },
        
          table: {
            
            display: 'table',
            width: '100%',
            borderStyle: 'solid',
            borderWidth: 1,
            borderColor: '#000',
          },
          row: {
            flexDirection: 'row',
            borderBottom: '1px solid #000',
          },
          cell: {
            padding: 5,
            borderRight: '1px solid #000',
            verticalAlign: 'middle',
          },
          headerCell: {
            fontWeight: 'bold',
            backgroundColor: '#f2f2f2',
          },
          // Column specific styles (adjust widths for each column)
          srNoCell: {
            width: '5%', 
          },
          detailsCell: {
            width: '55%', 
          },
          pageNoCell: {
            width: '40%', 
          },

          bulletRow: {
            flexDirection: 'row',
            alignItems: 'flex-start',
            marginBottom: 6, 
          },
          bulletSymbol: {
            width: 10,
            fontSize: 10,
            marginRight: 5, 
          },
          bulletText: {
            flex: 1,
            fontSize: 10,
            textAlign: 'justify',
            lineHeight: 1.5,
          },
          


        });


        
        
const Form6P2S1 = ({ result }) => {

    const tableData = [
        ['1', 'Name of the Government servant ', result.employeeName],
        ['2', `Class of pension or gratuity`,result.typeOfRetirement],
        ['3', `Amount of pension authorized`, 'not authorized'],
        ['4', 'Amount of gratuity authorized', `not authorized`],
        ['5', 'Date of commencement of pension', 
          result?.dateOfRetirement
          ? (() => {
              const [d, m, y] = result.dateOfRetirement.split('/').map(Number);
              const date = new Date(y, m - 1, d);
              date.setDate(date.getDate() + 1);
              return `${String(date.getDate()).padStart(2, '0')}/${String(date.getMonth() + 1).padStart(2, '0')}/${date.getFullYear()}`;
            })()
          : 'N/A'
       ],
        ['6', 
            `Amount of family pension in the event of death after retirement
            (i) if death takes place before 
                65 years of age	
            (ii) if death takes place after  
                65 years of age.`, 'not authorized'],
        ['7', 'The amount of relief admissible on pension.', 'As per Govt. rule '],
        ['8', 'He Government dues recoverable out of gratuity before authorising its payment.', 'NIL'],
        ['9', 'The amount of gratuity held over  for adjustment of unassesed Govt. dues.', 'NIL'],
        ['10', 'Date on which the pension appears received by the Audit Officer.', ''],
      ];
      
  
  return (
    <View size="A4" style={style.page}> 
                <Text style={[style.title, style.ArialBold]}>PART II</Text>
                <Text style={[style.subtitle, { fontSize: 10 }]}>Section II</Text>

               {/* Table */}
                   <View style={styles.table}>
                    
                     {/* Table Data */}
                     {tableData.map(([srNo, details, value], index) => (
                      <View style={styles.row} key={index}>
                        <Text style={[styles.cell, styles.srNoCell]}>{srNo}</Text>
                        <Text style={[styles.cell, styles.detailsCell]}>{details}</Text>
                        <AutoText style={[styles.cell, styles.pageNoCell]}>{value}</AutoText>
                      </View>
                    ))}
              </View>


              <Text style={[ style.ArialItalic,{ fontSize: 8 },{marginRight :50}, {textAlign: 'right'}, {marginTop: 80}]}>Head of Office.</Text>
        
              </View>

);
};

export default Form6P2S1;